module.exports = __webpack_public_path__ + "img/web-P4-3-2.6bdb9c7b.svg";